import React from 'react';

const About = () => {
    return (
        <section className="about-section py-5 mt-5 p-2" id='about'>
            <div className="container">
                <div className="row">
                    {/* Left Column (Heading and Description) */}
                    <div className="col-md-6 content-section align-items-center">
                        <h2 className="heading">Your Data, Visualized 
                        in Cloud</h2>
                        <p className="description me-md-5">
                        We specialize in delivering innovative and efficient solutions tailored to your needs.
                        Our dedicated team ensures top-notch services, making your journey seamless and productive.
                        Explore how we can transform your vision into reality with cutting-edge tools and expertise, empowering your 
                        business to achieve its goals through creativity while fostering growth and success.
                        </p>
                    </div>
                    {/* Right Column (Image) */}
                    <div className="col-md-6 align-items-center text-center">
                        <img 
                            src="../images/about.png" 
                            alt="About Us" 
                            className="about-image img-fluid"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
